import { jsx as x } from "react/jsx-runtime";
import { c as d } from "../../index-2QXL0WYc.js";
import { GlobalCSSClass as T, TextMode as c, TextElement as p, TextAlign as B, TextVariant as $ } from "../../enums.js";
const e = ({
  align: t,
  children: a,
  className: r,
  "data-testid": i,
  element: l = "div",
  mode: s,
  noGutter: n,
  variant: o,
  ...m
}) => /* @__PURE__ */ x(
  l,
  {
    ...m,
    className: d(r, "iress-u-text", {
      [`iress--${o}`]: !!o,
      [`iress--${s}`]: !!s,
      [`${T.TextAlignBase}--${t}`]: !!t,
      "iress--no-gutter": n
    }),
    "data-testid": i,
    children: a
  }
);
e.Mode = c;
e.Element = p;
e.Align = B;
e.Variant = $;
export {
  e as IressText
};
